"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skip = void 0;
const skip = (input, start, test) => {
    let end = start;
    const inputLength = input.length;
    while (end <= inputLength) {
        const cp = input.codePointAt(end);
        if (!test(cp)) {
            break;
        }
        end += 0xFFFF < cp ? 2 : 1;
    }
    return end;
};
exports.skip = skip;
